import { Action, Edit2Icon, BrokenGclose } from '../../../assets/Icons';
import { CustomPopover } from '../../../components/atoms';
import { ActionCON } from '../../style';
import { useState } from 'react';
import { useMutationHook } from '../../../network/mutations/useMutationHook';
import { useQueryClient } from 'react-query';
import { deletRole } from '../../../network/services/admin/roles';
import { UpdateRole } from '../../../pages';

export const RoleActions = ({ role }: any) => {
  const [value, setValue] = useState<HTMLElement | null>(null);
  const [isUpdate, setUpdate] = useState<boolean>(false);
  const queryClient = useQueryClient();

  const handleOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (value != null) {
      setValue(null);
    } else {
      setValue(event.currentTarget);
    }
  };

  const { mutateAsync } = useMutationHook(deletRole);
  const _delete = async (id: number) => {
    try {
      await mutateAsync(id);
      queryClient.invalidateQueries('admin_roles');
    } catch (error: any) {}
  };

  const _update = (id?: any) => {
    setUpdate(true);
  };

  const options = [
    {
      label: 'Update',
      value: 'Update',
      Icon: Edit2Icon,
      handleAction: _update
    },
    {
      label: 'Delete',
      value: 'Delete',
      Icon: BrokenGclose,
      color: '#D90429',
      handleAction: _delete
    }
  ];


  return (
    <div>
      <ActionCON aria-describedby="role-actions" onClick={event => handleOpen(event)}>
        <Action />
        <CustomPopover item={role.id} id="role-actions" open={value} options={options} />
        {isUpdate && <UpdateRole name={role.roleName} id={role.id} onModalClose={() => setUpdate(false)} />}
      </ActionCON>
    </div>
  );
};
